import { Button, DataSource, Layout, Panel, Table, Textbox, } from "@mcleod/components";

export abstract class AutogenLayoutRecentCallins extends Layout {
    buttonButton1: Button;
    panel1: Panel;
    sourceCallin: DataSource;
    tableCallins: Table;
    textbox1: Textbox;
}
